import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    cuentas: [],
    nodos: [],
};

const mutations = {
    'INICIALIZAR'(state) {
        state.cuentas = [];
        state.nodos = [];
    },
    'SET_PLAN_CUENTAS'(state, cuentas) {
        state.cuentas = cuentas;

        state.cuentas.sort(function(a, b){
            let x = a.codigo;
            let y = b.codigo;
            if (x < y) { 
                return -1; 
            }
            if (x > y) {
                return 1;
            }
            return 0;
        });

        cuentas.forEach(cuenta => {

            let nodoCuenta = {
                id: 'c' + cuenta.id.toString().trim(),
                // pId: 0,
                text: cuenta.codigo.trim() + ' - ' + cuenta.nombre.trim(),
                data: {
                    cuentaId: cuenta.id,
                    rubroId: 0,
                    subrubroId: 0,
                    level: 0,
                },
                children: []
            }

            state.nodos.push(nodoCuenta);
    
            if (cuenta.rubros) {
                cuenta.rubros.sort(function(a, b){
                    let x = a.codigo;
                    let y = b.codigo;
                    if (x < y) { 
                        return -1; 
                    }
                    if (x > y) {
                        return 1;
                    }
                    return 0;
                });

                cuenta.rubros.forEach(rubro => {
                    let nodoRubro = {
                        id: 'r' + rubro.id.toString().trim(),
                        // pId: 'c' + cuenta.id.toString().trim(),
                        text: cuenta.codigo.trim() + rubro.codigo.trim() + ' - ' + rubro.nombre.trim(),
                        data: {
                            cuentaId: cuenta.id,
                            rubroId: rubro.id,
                            subrubroId: 0,
                            level: 1,
                        },
                        children: []
                    }
                    nodoCuenta.children.push(nodoRubro);

                    if (rubro.subrubros) {
                        rubro.subrubros.sort(function(a, b){
                            let x = a.codigo;
                            let y = b.codigo;
                            if (x < y) { 
                                return -1; 
                            }
                            if (x > y) {
                                return 1;
                            }
                            return 0;
                        });
        
                        rubro.subrubros.forEach(subrubro => {
                            let nodoSubrubro = {
                                id: 's' + subrubro.id.toString().trim(),
                                // pId: 'r' + rubro.id.toString().trim(),
                                text: cuenta.codigo.trim() + rubro.codigo.trim() + subrubro.codigo.trim() + ' - ' + subrubro.nombre.trim(),
                                data: {
                                    cuentaId: cuenta.id,
                                    rubroId: rubro.id,
                                    subrubroId: subrubro.id,
                                    level: 2,
                                },
                                children: []
                            }

                            nodoRubro.children.push(nodoSubrubro);
                        });
                    }
                });
            }
        });
    },

    // 'SET_PLAN_CUENTAS'(state, cuentas) {
    //     state.cuentas = cuentas;

    //     state.cuentas.sort(function(a, b){
    //         let x = a.codigo;
    //         let y = b.codigo;
    //         if (x < y) { 
    //             return -1; 
    //         }
    //         if (x > y) {
    //             return 1;
    //         }
    //         return 0;
    //     });

    //     cuentas.forEach(cuenta => {
    //         state.nodos.push({
    //                 id: 'c' + cuenta.id.toString().trim(),
    //                 pId: 0,
    //                 name: cuenta.codigo.trim() + ' - ' + cuenta.nombre.trim(),
    //                 cuentaId: cuenta.id,
    //                 rubroId: 0,
    //                 subrubroId: 0
    //             });
    
    //         if (cuenta.rubros) {
    //             cuenta.rubros.sort(function(a, b){
    //                 let x = a.codigo;
    //                 let y = b.codigo;
    //                 if (x < y) { 
    //                     return -1; 
    //                 }
    //                 if (x > y) {
    //                     return 1;
    //                 }
    //                 return 0;
    //             });

    //             cuenta.rubros.forEach(rubro => {
    //                 state.nodos.push({
    //                     id: 'r' + rubro.id.toString().trim(),
    //                     pId: 'c' + cuenta.id.toString().trim(),
    //                     name: cuenta.codigo.trim() + rubro.codigo.trim() + ' - ' + rubro.nombre.trim(),
    //                     cuentaId: cuenta.id,
    //                     rubroId: rubro.id,
    //                     subrubroId: 0
    //                 });

    //                 if (rubro.subrubros) {
    //                     rubro.subrubros.sort(function(a, b){
    //                         let x = a.codigo;
    //                         let y = b.codigo;
    //                         if (x < y) { 
    //                             return -1; 
    //                         }
    //                         if (x > y) {
    //                             return 1;
    //                         }
    //                         return 0;
    //                     });
        
    //                     rubro.subrubros.forEach(subrubro => {
    //                         state.nodos.push({
    //                             id: 's' + subrubro.id.toString().trim(),
    //                             pId: 'r' + rubro.id.toString().trim(),
    //                             name: cuenta.codigo.trim() + rubro.codigo.trim() + subrubro.codigo.trim() + ' - ' + subrubro.nombre.trim(),
    //                             cuentaId: cuenta.id,
    //                             rubroId: rubro.id,
    //                             subrubroId: subrubro.id
    //                         });
    //                     });
    //                 }
    //             });
    //         }
    //     });
    // },
};

const actions = {
    inicializarPlanCuentas: ( { commit } )  => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            apiAxios.get('cuentas/list')
                .then(res => {
                    commit('SET_PLAN_CUENTAS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}